import { createAction } from 'redux-actions'
import { parseDate } from '../../utils/dateUtils'
import { validateDates } from '../../logic/bookableDatesLogic'
import {
  checkInDateSelector,
  checkOutDateSelector,
  isProgramBookingSelector,
  validateTnc
} from '../modules/searchParamsModule'
import { populateFormErrors } from '../modules/errorDialogModule'
import { findRooms } from '../actions'
import { isAuthenticatedSelector } from '../selectors/authSelector'
import { pathnameSelector } from '../modules/routeModule'
import history from '../../history'

export const closeWarningDialog = createAction('CLOSE_TIMEOUT_EXTEND_DIALOG')
export const openWarningDialog = createAction('OPEN_TIMEOUT_EXTEND_DIALOG')
export const extendTime = createAction('EXTEND_TIME')

export function roomSearchClick() {
  return (dispatch, getState) => {
    const state = getState()
    const checkInDate = checkInDateSelector(state)
    const checkOutDate = checkOutDateSelector(state)
    const authenticated = isAuthenticatedSelector(state)
    const currentLocation = pathnameSelector(state)
    const isProgramBooking = isProgramBookingSelector(state)

    let today = parseDate(new Date())
      .startOf('hour')
      .hour(0)
    let validateResult = validateDates(
      authenticated,
      isProgramBooking,
      checkInDate,
      checkOutDate,
      today
    )

    return dispatch(validateTnc())
      .catch(() => {})
      .then(() => {
        if (!validateResult.valid) {
          return dispatch(
            populateFormErrors({
              messages: validateResult.errors,
              popupError: true
            })
          )
        } else {
          return dispatch(findRooms(checkInDate, checkOutDate)).then(() => {
            if (currentLocation !== '/results') {
              history.push('/results')
            }
          })
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/searchActions.js